const ButtonAdmin = ({ startContent, endContent, children, ...props }) => {
  return (
    <div className="d-flex justify-content-center">
      <button
        className="btn btn-primary d-flex align-items-center"
        style={{ gap: "12px" }}
        {...props}
      >
        {startContent}
        {children}
        {endContent}
      </button>
    </div>
  );
};

export default ButtonAdmin;
